
import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';
import {CREATE_QNA} from "../actions/type";

export const initialState = {
  token: '',
  userInfo: {} ,
  isProcessing: false,
  statusCode: null,
};


const qnaReducers = (state  = initialState, action) => {
  switch (action.type) {

    case actionTypes.CREATE_QNA:
      console.log('authReducers', action.type);
      return {
        ...state,
        isProcessing: true,
        type: action.type
      };
    case actionTypes.CREATE_SUCCESS:
      let res = action.payload;
      console.log('CREATE_SUCCESS qna', res);
      return {
        ...state,
      };
    case actionTypes.CREATE_FAILD:
      console.log('CREATE_FAILD qna', action);
      return {
        ...state,
        isProcessing: false,
      }
    default:
      return state;
  }
};

export default qnaReducers;
